import { h } from 'preact';

import { preactLifecycleComponent } from 'common/module/preact/lifecycle-component';
import { PreactLifecycleComponentPropsInterface } from 'common/module/preact/lifecycle-component-props.interface';

const Markup = () => <div className='recaptcha' />;

export const GoogleRecaptchaTemplate = preactLifecycleComponent<PreactLifecycleComponentPropsInterface>(Markup);
